import { useTranslation } from 'react-i18next';
import { RefObject } from 'react';
import { usePricingContext } from 'services/contexts/PricingContext/PricingProvider';
import { IProduct, ProductType } from 'services/api/entities/stripe/product';
import { getYearlyPrice } from '../../helpers';
import { DistroPlusAnchor } from './components';
import {
  StyledBillingTypography,
  StyledContainer,
  StyledTypography,
} from './styled';

type DiscountInfoProps = {
  product: IProduct;
  distributionRef: RefObject<HTMLDivElement | null>;
};

const PlanInfo = ({ product, distributionRef }: DiscountInfoProps) => {
  const { t } = useTranslation();
  const { isAnnualPaymentSelected } = usePricingContext();

  const { information, prices } = product;
  const { productType } = information;

  const handleScroll = () => {
    distributionRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  if (productType === ProductType.Free) {
    return (
      <StyledTypography>
        {t('subscription:priceTag:noCreditCardRequired')}
      </StyledTypography>
    );
  }

  const annualConst = getYearlyPrice(prices).yearlyIntValue();

  const billingPeriod = isAnnualPaymentSelected
    ? `${t('subscription:priceTag:billedAnnually')} ($${annualConst}/${t(
        'subscription:priceTag:year'
      )})`
    : t('subscription:priceTag:billedMonthly');

  return (
    <StyledContainer>
      <StyledBillingTypography>{billingPeriod}</StyledBillingTypography>

      {isAnnualPaymentSelected && (
        <DistroPlusAnchor handleScroll={handleScroll} />
      )}
    </StyledContainer>
  );
};

export default PlanInfo;
